import { c as _c } from "react/compiler-runtime";
import { translate } from '@openclassrooms/translations';
import { ROUTES, getPathName } from '@openclassrooms/routing';
import { useLocalisationConfig } from '@openclassrooms/localisation/LocalisationConfigProvider';
import FAQ from '@classify/react-marketing-components/FAQ';
import Recommended from './Recommended';
export default function RecommendedEmployer() {
  const $ = _c(12);
  const {
    getLocalisationConfig
  } = useLocalisationConfig();
  const canDisplayFAQBlock = getLocalisationConfig("contact.faq.show");
  if (!canDisplayFAQBlock) {
    return null;
  }
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = translate("global.word.expand");
    t1 = {
      question: translate("business.uplift.faq.question_how_work"),
      answer: translate("business.uplift.faq.answer_how_work")
    };
    t2 = {
      question: translate("business.uplift.faq.question_how_recruit"),
      answer: translate("business.uplift.faq.answer_how_recruit")
    };
    t3 = translate("business.uplift.faq.question_cost");
    t4 = translate("business.uplift.faq.answer_cost", {
      link: getPathName(ROUTES.BUSINESS.CONTACT)
    });
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t4) {
    t5 = {
      question: t3,
      answer: t4
    };
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  let t7;
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      question: translate("business.uplift.faq.question_duration"),
      answer: translate("business.uplift.faq.answer_duration")
    };
    t7 = {
      question: translate("business.uplift.faq.question_rythm"),
      answer: translate("business.uplift.faq.answer_rythm")
    };
    t8 = {
      question: translate("business.uplift.faq.question_contract_type"),
      answer: translate("business.uplift.faq.answer_contract_type")
    };
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
  } else {
    t6 = $[7];
    t7 = $[8];
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t5) {
    t9 = <Recommended><FAQ expandAriaLabel={t0} items={[t1, t2, t5, t6, t7, t8]} /></Recommended>;
    $[10] = t5;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  return t9;
}